'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');
var constants = require('../../constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Navbar = styled__default["default"].nav(({ grid }) => {
  const {
    linksGridRow,
    linksGridColumn,
    navigationJustifySelf,
    menuItemSpacing
  } = grid;
  return `
    grid-row: ${linksGridRow};
    grid-column: ${linksGridColumn};
    justify-self: ${navigationJustifySelf};
    height: 100%;
    margin-left: ${-1 * menuItemSpacing}px;
  
    @media screen and (max-width: ${constants.MOBILE_WIDTH}px){
      grid-row: unset;
      grid-column: unset;
    };
  `;
});

exports.Navbar = Navbar;
